import React, { useState } from "react"
import ModelPageNavigation from "../ModelPageNavigation"

import "./chapterList.scss"

const ChapterList = (props) => {
  let {
    chapters,
    isTutorial,
    selectedChapter,
    selectedPage,
    selectedItem,
  } = props

  const [onClickChapter, setOnClickChapter] = useState("")

  const setChapterName = (value) => {
    setOnClickChapter(value)
  }

  return !chapters ? null : (
    <div className="chapter-container">
      <div className="chapter-list">
        {chapters.map((chapter, idx) => {
          const pages = chapter.pages.map((page) => {
            if (page.slug) {
              return {
                displayName: page.displayName,
                path: page.slug,
                tooltip: page.tooltip || "",
                itemName: page.itemName,
              }
            }

            return {
              displayName: page.displayName,
              pageName: page.pageName,
              path: `${chapter.path}?page=${encodeURIComponent(
                page.pageName
              )}&tutorial=${isTutorial}`,
            }
          })

          if (chapter.whitePaperUrl) {
            pages.push({
              displayName: "White Paper",
              path: chapter.whitePaperUrl,
            })
          }

          return (
            <ModelPageNavigation
              isReportSelected={
                chapter.path.toLowerCase() ===
                selectedChapter.path.toLowerCase()
              }
              showMenu={
                onClickChapter.toLowerCase() === chapter.name.toLowerCase()
              }
              setOnClickChapter={setChapterName}
              selectedPage={selectedPage}
              selectedItem={selectedItem}
              key={idx}
              path={chapter.path}
              menuName={chapter.name}
              items={pages}
              isTutorial
            />
          )
        })}
      </div>
    </div>
  )
}

export default ChapterList
